import React, { useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import '../Forms.css';
import FormButton from '../../Components/FormButton';
import { useNavigate } from 'react-router-dom';
import InputField from '../../Components/InputFeild';
import { useSelector,useDispatch } from 'react-redux';
import { verifyUser } from '../../Redux/Actions/UserActions';
import { useTranslation } from 'react-i18next';

const OtpVerify = () => {
    const [otp, setOtp] = useState(new Array(6).fill(''));
    const Navigate = useNavigate();
    const Dispatch = useDispatch()
    const { UserData } = useSelector((state) => state.User);
    const userEmail = UserData?.data?.email;
    const {t}=useTranslation()
    const handleChange = (element, index) => {
        if (/^[0-9]$/.test(element.value) || element.value === '') {
            const newOtp = [...otp];
            newOtp[index] = element.value;
            setOtp(newOtp);
            if (element.value !== '' && index < 5) {
                document.getElementById(`otp-${index + 1}`).focus();
            }
        }

        if (element.value === '' && index > 0) {
            const newOtp = [...otp];
            newOtp[index] = '';
            setOtp(newOtp);
            document.getElementById(`otp-${index - 1}`).focus();
        }
    };


    const handleSubmit = (event) => {
        event.preventDefault();
        if (isOtpComplete()) {
            const otpCode = otp.join('');
            const data = {
                email:userEmail,
                code:otpCode
            }
            Dispatch(verifyUser(data, Navigate))
            setOtp(new Array(6).fill(''));
        }
    };

    const isOtpComplete = () => otp.every(digit => digit !== '');

    const handleCancelButton = () => {
        Navigate(-1);
    };

    return (
        <Container className='my-5 py-5 text-center'>
            <form onSubmit={handleSubmit} className='verify-form'>
                <Row className='justify-content-center gap-4 flex-wrap'>
                    <h1 className='fw-semibold'>{t("Please Verify Your Account")}</h1>
                    <p className='text-wrap'>
                     {t("Enter the six-digit code we sent to your email address to verify your new Nogard account:")}
                    
                    </p>
                    <div className="d-flex justify-content-center">
                        {otp.map((data, index) => (
                            <InputField
                                type="tel"
                                maxLength="1"
                                key={index}
                                id={`otp-${index}`}
                                value={data}
                                onChange={(e) => handleChange(e.target, index)}
                                onFocus={(e) => e.target.select()}
                                style={{
                                    width: '40px',
                                    height: '60px',
                                    margin: '0 5px',
                                    textAlign: 'center',
                                    fontSize: '24px',
                                    ...(otp.filter(digit => digit !== '').length > 1 ? { backgroundColor: 'rgba(236, 236, 236, 1)', border: '1px solid rgba(133, 139, 189, 1)' } : {})
                                }}
                            />
                        ))}
                    </div>
                    <div className="d-flex justify-content-center">
                        <FormButton
                            Buttontext={t('Verify & Continue')}
                            className='py-2 px-3 verify-btn'
                            type="submit"
                            disabled={!isOtpComplete()}
                        />
                    </div>
                    <p onClick={handleCancelButton} className='cancel-btn'>{t('Cancel')}</p>
                </Row>
            </form>
        </Container>
    );
};

export default OtpVerify;
